import React, { useCallback, useState } from 'react';
import { FlightTextInput } from '@flybits/design-system';
import { ReactComponent as ClearIcon } from 'assets/icons/clear-icon-outline.svg';
import { ReactComponent as SearchIcon } from 'assets/icons/search-icon.svg';
import debounce from 'lodash/debounce';
import './SearchBarPage.scss';

interface Props {
  initialValue?: string;
  handleSearchTermChange: (value: string) => void;
  className?: string;
  placeholder?: string;
  width?: string;
}

export default function SearchBarPage(props: Props) {
  const { initialValue, handleSearchTermChange, className, width, placeholder } = props;
  const [searchTerm, setSearchTerm] = useState(initialValue || '');
  const MAIN_CLASS = 'search-bar-page';

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedSearch = useCallback(
    debounce((value: string) => {
      handleSearchTermChange(value);
    }, 500),
    [],
  );

  function handleSearchInput(value: string) {
    setSearchTerm(value);
    if (!value) {
      debouncedSearch.cancel();
      handleSearchTermChange('');
      return;
    }
    debouncedSearch(value);
  }

  return (
    <div className={MAIN_CLASS + (className ? ` ${className}` : '')}>
      <FlightTextInput
        type="text"
        width={width}
        value={searchTerm}
        placeholderText={placeholder}
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        onChange={(e: any) => handleSearchInput(e.target.value)}
        label={placeholder}
      />
      {searchTerm?.length > 0 ? (
        <ClearIcon
          tabIndex={0}
          className={`${MAIN_CLASS}__icon`}
          aria-label="Clear search"
          onKeyDown={(event) => {
            if (event.key === 'Enter') {
              handleSearchInput('');
            }
          }}
          onClick={() => {
            handleSearchInput('');
          }}
        />
      ) : (
        <SearchIcon tabIndex={-1} className={`${MAIN_CLASS}__icon`} />
      )}
    </div>
  );
}
